import { updateMspGeneral } from "stores/slice/bogus/settingsGeneral/msp/const";
import { updateOrgGeneral } from "stores/slice/bogus/settingsGeneral/org/const";
import { updateSiteGeneral } from "stores/slice/bogus/settingsGeneral/site/const";

const settingsGeneralConfig = {
  // API/gluon/enterprise -> /ents/{entId}/settings/general
  "/ents/:entId/settings/general.read": {
    protocol: "ws",
    resource: "/ents/:entId/settings/general",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "mspGeneral",
  },
  // API/gluon/enterprise -> /ents/{entId}/settings/general
  "/ents/:entId/settings/general.update": {
    protocol: "ws",
    resource: "/ents/:entId/settings/general",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateMspGeneral,
    mockSelector: "mspGeneral",
  },
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/settings/general
  "/ents/:entId/orgs/:orgId/settings/general.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/general",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "orgGeneral",
  },
  // API/gluon/organizations => /orgs/{orgId}/settings/general (standalone)
  "/orgs/:orgId/settings/general.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/general",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "orgGeneral",
  },
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/settings/general
  "/ents/:entId/orgs/:orgId/settings/general.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/general",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateOrgGeneral,
    mockSelector: "orgGeneral",
  },
  // API/gluon/organizations => /orgs/{orgId}/settings/general (standalone)
  "/orgs/:orgId/settings/general.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/general",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockSelector: "orgGeneral",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/general
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/general.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/general",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "siteGeneral",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/settings/general (standalone)
  "/orgs/:orgId/sites/:siteId/settings/general.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/general",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "siteGeneral",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/general
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/general.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/general",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateSiteGeneral,
    mockSelector: "siteGeneral",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/settings/general (standalone)
  "/orgs/:orgId/sites/:siteId/settings/general.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/general",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateSiteGeneral,
    mockSelector: "siteGeneral",
  },
};

export default settingsGeneralConfig;
